/**
 * The local Firebase emulators — used ONLY by the browser E2E run (`npm run test:e2e`).
 *
 * `VITE_USE_EMULATORS` is set by the committed root `.env.e2e`, i.e. only in the Vite
 * mode `e2e` (`npm run start:e2e -w apps/web`). Every other mode — `npm start`, the
 * production build — leaves it unset, so this flag is false and the connect calls in
 * `firebase.js`, `utils/storageUtils.js` and `utils/callFunction.js` are dead code
 * there: a real build can never talk to an emulator by accident.
 *
 * The ports are the `emulators` block of `firebase.json`. They are written out here
 * because the bundle cannot read that file; `tests/gates/e2eHarness.test.js` fails the
 * moment the two disagree.
 */
export const USE_EMULATORS = import.meta.env.VITE_USE_EMULATORS === "true";

export const EMULATOR_HOST = "127.0.0.1";

export const EMULATOR_PORTS = Object.freeze({
  auth: 9099,
  firestore: 8080,
  storage: 9199,
  functions: 5001,
});
